import ApiService from "../../services/ApiService";
import Logger from "../../services/Logger";

const AdminFeedbackService = {
    /**
     * @param {number} page - zero-based page index
     * @param {number} pageSize
     * @param {string} sort - e.g. "createdAt:desc" (backend-specific)
     */
    list: async (page = 0, pageSize = 25, sort = "createdAt:desc") => {
        try {
            const response = await ApiService.getData("/v1/feedback", { page, pageSize, sort });
            return {
                success: true,
                data: response
            };
        } catch (error) {
            Logger.error("Error fetching feedback list:", error);
            return {
                success: false,
                error: error.message || "Failed to fetch feedback"
            };
        }
    },

    findById: async (feedbackId) => {
        try {
            const response = await ApiService.getData(`/v1/feedback/${feedbackId}`);
            return {
                success: true,
                data: response
            };
        } catch (error) {
            Logger.error("Error fetching feedback:", error);
            return {
                success: false,
                error: error.message || "Failed to fetch feedback"
            };
        }
    },

    /**
     * POST /v1/feedback/{feedbackId}/reply — sends email reply (MANAGER/ADMIN).
     * @param {string} feedbackId
     * @param {string} message
     */
    replyByEmail: async (feedbackId, message) => {
        try {
            const response = await ApiService.postData(`/v1/feedback/${feedbackId}/reply`, { message });
            if (response && response.code === "FAILURE") {
                return {
                    success: false,
                    error: response.message || "Reply failed"
                };
            }
            return {
                success: true,
                data: response
            };
        } catch (error) {
            Logger.error("Error sending feedback reply:", error);
            return {
                success: false,
                error: error.message || "Failed to send reply"
            };
        }
    },

    /**
     * DELETE /v1/feedback/{feedbackId} — removes the feedback row (MANAGER/ADMIN).
     * @param {string} feedbackId
     */
    delete: async (feedbackId) => {
        try {
            const response = await ApiService.deleteData(`/v1/feedback/${feedbackId}`);
            if (response && response.code === "FAILURE") {
                return {
                    success: false,
                    error: response.message || "Delete failed"
                };
            }
            return {
                success: true,
                data: response
            };
        } catch (error) {
            Logger.error("Error deleting feedback:", error);
            return {
                success: false,
                error: error.message || "Failed to delete feedback"
            };
        }
    }
};

export default AdminFeedbackService;
